<template lang="pug">
  DrawerContents
    .child(v-for="child in children" :key="child.product.productId")
      .main-line(@click="updateChild(child, child.buyRequest.qty === 0)")
        Checkbox(:label="child.name" :id="`drawer-checkbox-${child.product.productId}`" :modelValue="child.buyRequest.qty > 0" @click.stop @update:modelValue="updateChild(child, $event)")
        Price(:buyRequest="child.buyRequest" theme="rhpa-child")
      ConfigureBuyRequest(
        v-if="child.buyRequest.qty > 0"
        :buyRequest="child.buyRequest"
      )
      //- The 500LB/1000LB sets are a custom mix, so the breakdown has to be picked here - the checkbox
      //- above bypasses the quantity stepper that opens the drawer everywhere else (EDEV-2094)
      BumperSelector(
        v-if="child.buyRequest.qty > 0 && needsBumperBreakdown(child.product)"
        :buyRequest="child.buyRequest"
        :editing="true"
      )
      .bundle(v-if="child.product.type === 'bundle' && child.buyRequest.qty > 0")
        bundle-option(
          v-for="bundleChild in child.buyRequest.children?.filter(c => (c.metadata || {}).bundleOptionId)"
          :key="bundleChild.productId"
          :bundleBuyRequest="child.buyRequest"
          :buyRequest="bundleChild"
        )
    RogueButton(#bottom width="full" :disabled="nothingSelected || missingBreakdown" color="red" @click="$emit('done')") {{__('Add Items to {type}', {type: listType})}}
</template>
<script>
import { defineAsyncComponent } from 'vue'
import { computePriceSync } from '../helpers/price-utils'
import { useProductStore } from '@/js/stores/productStore'
import { missingBumperSetBreakdown, needsBumperSetBreakdown } from '@/js/helpers/bumper-set'

export default {
  name       : 'AddGroupedToList',
  components : {
    BundleOption   : defineAsyncComponent(() => import(/* webpackChunkName: "bundle-group" */'@/js/components/rhpa/bundle-option.vue')),
    BumperSelector : defineAsyncComponent(() => import(/* webpackChunkName: "bumper-set-breakdown" */'@/js/pages/product/components/bumper-set-breakdown/bumper-selector.vue')),
  },
  props: {
    buyRequest: {
      type     : Object,
      required : true,
    },
    listType: {
      type     : String,
      required : true,
    },
  },
  emits: ['done'],
  setup() {
    const productStore = useProductStore()

    return { productStore }
  },
  computed: {
    products() {
      return this.productStore.products
    },
    nothingSelected() {
      return this.buyRequest.children?.filter(buyRequest => buyRequest.qty > 0).length === 0
    },
    // A set whose plates don't add up to its weight can't be saved to the list
    missingBreakdown() {
      return (this.buyRequest.children || [])
        .some(child => child.qty > 0 && missingBumperSetBreakdown(child, this.products))
    },
    product() {
      return this.products[this.buyRequest.productId]
    },
    children() {
      return this.buyRequest.children?.map(child => ({
        name       : this.products[child.productId].name,
        price      : computePriceSync({ ...child, qty: 1 }, this.$rogue.pinia, { parent: this.buyRequest }),
        product    : this.products[child.productId],
        buyRequest : child,
      }))
    },
  },
  methods: {
    updateChild(child, val) {
      child.buyRequest.qty = val ? 1 : 0
    },
    needsBumperBreakdown(product) {
      return needsBumperSetBreakdown(product)
    },
  },
}
</script>
<style lang="scss" scoped>

.main-line {
  display: flex;
  height: 42px;
  margin-bottom: $space-s;
  cursor: pointer;
  justify-content: space-between;
  align-items: center;
}

</style>
